import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { UpdateGeneralInformationContactValidationSchema } from "../schemas/updateGeneralInformationContact.schema";

interface UseUpdateGeneralInformationContact {
  establishmentCompanyId: string;
  generalInformationId: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useUpdateGeneralInformationContact = ({ establishmentCompanyId, generalInformationId, onSuccess, onError }: UseUpdateGeneralInformationContact) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['increaseTefTableVersion'],
    mutationFn: async (form: UpdateGeneralInformationContactValidationSchema) => {
      const company_branch = {
        general_information_attributes: {
          id: generalInformationId,
          phone_attributes: {
            number: form.general_information.phone.number,
            kind: form.general_information.phone.kind,
            whatsapp_capable: form.general_information.phone.whatsapp_capable,
          }
        }
      }

      return await privateAxios.put(`/establishment/company_branches/${establishmentCompanyId}`, {company_branch})
    },
    onSuccess,
    onError
  })
}

export default useUpdateGeneralInformationContact
